

const AdminFooter = () => {
  return (
    <div
      className="copyright flex items-center justify-center"
      style={{
        background: "#e8e8e8",
      }}
    >
      <span className="p-3">
        Copyright &copy; 2023 IISPL BD. All rights reserved.
      </span>
    </div>
  );
};

export default AdminFooter;
